import api from './api';

// 지식베이스 API 함수들
const knowledgeBaseApi = {
  // 지식베이스 생성
  createKnowledgeBase: async (knowledgeBaseData) => {
    const response = await api.post('/knowledge-base', knowledgeBaseData);
    return response.data;
  },
  
  // 지식베이스 목록 가져오기
  listKnowledgeBases: async () => {
    const response = await api.get('/knowledge-base');
    return response.data;
  },
  
  // 지식베이스 정보 가져오기
  getKnowledgeBase: async (kbId) => {
    const response = await api.get(`/knowledge-base/${kbId}`);
    return response.data;
  },
  
  // 지식베이스 업데이트
  updateKnowledgeBase: async (kbId, knowledgeBaseData) => {
    const response = await api.put(`/knowledge-base/${kbId}`, knowledgeBaseData);
    return response.data;
  },
  
  // 지식베이스 삭제
  deleteKnowledgeBase: async (kbId) => {
    const response = await api.delete(`/knowledge-base/${kbId}`);
    return response.data;
  },
  
  // 인덱스 생성
  createIndex: async (kbId, indexData) => {
    try {
      console.log(`인덱스 생성 API 호출: POST /knowledge-base/${kbId}/index`);
      console.log(`요청 데이터:`, JSON.stringify(indexData, null, 2));
      
      const response = await api.post(`/knowledge-base/${kbId}/index`, indexData);
      console.log(`인덱스 생성 응답:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`인덱스 생성 API 오류:`, error);
      console.error(`인덱스 생성 API 오류 상세:`, error.response?.data || error.message);
      // 오류를 상위로 전파하여 UI에서 처리할 수 있도록 함
      throw error;
    }
  },
  
  // 인덱스 상태 확인
  getIndexStatus: async (kbId, indexId) => {
    const response = await api.get(`/knowledge-base/${kbId}/index/${indexId}`);
    return response.data;
  },
  
  // 인덱스 진행 상황 확인
  getIndexProgress: async (kbId, indexId) => {
    try {
      console.log(`요청: 인덱스 진행 상황 가져오기 (${kbId}/${indexId})`);
      const response = await api.get(`/knowledge-base/${kbId}/index/${indexId}/progress`);
      console.log(`응답 원본 데이터:`, response.data);
      
      // 응답에 필수 필드가 있는지 확인
      if (!response.data) {
        console.warn("API가 빈 응답을 반환했습니다");
        return null;
      }
      
      // 누락된 필드에 기본값 설정
      const progress = {
        ...response.data,
        percent_complete: response.data.percent_complete !== undefined ? response.data.percent_complete : 0,
        document_count: response.data.document_count !== undefined ? response.data.document_count : 0,
        embedding_count: response.data.embedding_count !== undefined ? response.data.embedding_count : 0,
        total_documents: response.data.total_documents !== undefined ? response.data.total_documents : 0,
        total_embeddings: response.data.total_embeddings !== undefined ? response.data.total_embeddings : 0,
        current_stage: response.data.current_stage || "준비 중"
      };
      
      console.log(`최종 가공된 진행 정보:`, progress);
      return progress;
    } catch (error) {
      console.error("인덱스 진행 상황을 가져오는 중 오류 발생:", error);
      return null;
    }
  },
  
  // 사용 가능한 소스 정보 가져오기 (크롤링, 문서, DB 등)
  getAvailableSources: async (kbId) => {
    try {
      const response = await api.get(`/knowledge-base/${kbId}/available-sources`);
      return response.data;
    } catch (error) {
      console.error("사용 가능한 소스 정보를 가져오는 중 오류 발생:", error);
      return {
        crawl_jobs: [],
        documents: [],
        database_connections: []
      };
    }
  }
};

export default knowledgeBaseApi; 